'use strict';

var Joi = require('joi');
var authMethods = require('../utils/authMethods.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var LandingPageAccountCreate = Joi__default["default"].object().keys({
  form_id: Joi__default["default"].string().guid({
    version: ['uuidv4']
  }).allow(null).description('The id of the landing page in Hype Forms table'),
  auth_method: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, authMethods).required().description('The auth method user used to sign up')
}).description('landing_page:account_create event attributes ').meta({
  name: 'LandingPageAccountCreate',
  filename: 'landing_page:account_create.model'
});
var LandingPageAccountCreate$1 = LandingPageAccountCreate;

module.exports = LandingPageAccountCreate$1;
//# sourceMappingURL=account_create.model.js.map
